import Project from "./project"
import ProjectTaskStatus from "./project-task-status"
import Transaction from "./transaction"
import ProjectBudget from "./project-budget"

export default interface ProjectTask {
    id: string
    projectId: string
    statusId?: string | null

    code: string
    isCompleted: boolean
    completedPercentage?: number | null
    startDate?: Date | null
    endDate?: Date | null
    createdAt: Date
    updatedAt: Date

    project?: Project
    status?: ProjectTaskStatus

    budgets?: ProjectBudget[]
    transactions?: Transaction[]
}


export class ProjectTaskUI {
    // Status values
    static readonly STATUS_COMPLETED = "Completed";
    static readonly STATUS_SUSPENDED = "Suspended";
    static readonly STATUS_IN_PLANNING = "In Planning";
    static readonly STATUS_ACTIVE = "Active";

    // CSS classes
    static readonly CLASS_SUCCESS = "success";
    static readonly CLASS_WARNING = "warning";
    static readonly CLASS_ERROR = "error";
    static readonly CLASS_ACTIVE = "active";

    static getStatusColor(status?: string): string {
        switch (status) {
            case ProjectTaskUI.STATUS_COMPLETED:
                return ProjectTaskUI.CLASS_SUCCESS;

            case ProjectTaskUI.STATUS_SUSPENDED:
                return ProjectTaskUI.CLASS_WARNING;

            case ProjectTaskUI.STATUS_IN_PLANNING:
                return ProjectTaskUI.CLASS_ERROR;

            case ProjectTaskUI.STATUS_ACTIVE:
                return ProjectTaskUI.CLASS_ACTIVE;

            default:
                return '';
        }
    }
}
